import axios from 'axios';
import { Resolver } from '../../../config';
import { FLOW_ID_HEADER } from '../../../common/constants';
import FaceTecStringsEn from './core-sdk-optional/FaceTecStrings.en';
import FaceTecStringsEs from './core-sdk-optional/FaceTecStrings.es';

export const FaceTecStringsLanguages: Record<string, Record<string, string>> = {
  en: FaceTecStringsEn,
  es: FaceTecStringsEs,
};

export type FacetecConfig = {
  facetecBaseURL: string;
  deviceKeyIdentifier: string;
  publicFaceScanEncryptionKey: string;
  licenseKey: string;
  productionMode: boolean;
};

type ConfigServiceResult = {
  url: string;
  deviceKeyIdentifier: string;
  encryptionPublicKey: string;
  browserLicenseKey: string;
};

let configCache: FacetecConfig | null = null;
const fetchFacetecConfig = async (): Promise<void> => {
  const serviceConfig = Resolver.getServiceConfig();
  const configResult: ConfigServiceResult = await axios
    .request<ConfigServiceResult>({
      url: serviceConfig.configEndpoint,
      method: 'GET',
      retryConfig: {
        retries: serviceConfig.networkRetryConfig.defaultRetries,
      },
      // Temporarily removing flow ID from header as CORS policy is currently blocking it
      transformRequest: (data, headers) => {
        // eslint-disable-next-line no-param-reassign
        delete headers.common[FLOW_ID_HEADER];
        return data;
      },
    })
    .then((response) => response.data);
  configCache = {
    deviceKeyIdentifier: configResult.deviceKeyIdentifier,
    facetecBaseURL: configResult.url,
    publicFaceScanEncryptionKey: configResult.encryptionPublicKey,
    licenseKey: configResult.browserLicenseKey,
    productionMode: serviceConfig.facetecProductionMode,
  };
};

const getFacetecConfig = (): FacetecConfig => {
  if (configCache === null) {
    throw new Error('No Facetec config loaded. Please call fetchFacetecConfig');
  }

  return configCache as FacetecConfig;
};

export default {
  fetchFacetecConfig,
  getFacetecConfig,
};
